import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap'
import PropTypes from "prop-types";
import {TableHeaderColumn} from "react-bootstrap-table";
import * as Date from "./utils/date"
import * as Grid from "./utils/grid";
import {hashHistory} from "react-router";

const formatRow = (row) => {
	return "row-clickable"
};

export default class Home extends Component {


	render() {
		const {seasons} = this.props;

		const cols = [
			<TableHeaderColumn key="1" dataField="title" width='70%' dataAlign="left">Název</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="dateFrom" width='15%' dataAlign="center" dataFormat={Date.formatDate}>Od</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="dateTo" width='15%' dataAlign="center" dataFormat={Date.formatDate}>Do</TableHeaderColumn>
		];

		const filter = {};
		const options = Grid.getTableOptions(filter);
		options.onRowClick = (row) => {
			hashHistory.push('/' + row.seasonId);
		};

		return (
			<div>
				<h2>
					Dostupné soutěže
				</h2>
				<Row>
					<Col xs={12}>
						{Grid.renderTable(seasons.items, seasons.items.length, options, cols, false, true, 'table-seasons', true, formatRow)}
					</Col>
				</Row>
			</div>
		);
	}
}


Home.propTypes = {
	seasons: PropTypes.object
};


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/Home.js